export default __webpack_public_path__ + "static/media/banner.bb80a635.jpg";